module.exports = __webpack_public_path__ + "static/media/4x6no3.9ef54e10.jpg";